import React, { memo } from 'react'

export const NotFound = memo(() => (
  <div>
    <h1>Page not found</h1>
  </div>
))
